import React from 'react';
import cx from 'classnames';
import useAsyncIcon from './useAsyncIcon';
import IconProps from './Icon.types';
import styles from './Icon.module.scss';
import iconsMap from './IconsImportMap';

const Icon = ({
  icon,
  className = styles?.icon,
  styleProps = {},
  width = '22',
  height = '22',
  viewBox = '0 0 1024 1024',
  title = null,
  fillColor = null,
  fill = 'none',
  fillRule = null,
  stroke = null,
  strokeWidth = null,
  dataCy = 'icon',
  ariaHidden = false,
}: IconProps) => {
  const name = icon?.toLowerCase();

  const iconResolver = iconsMap[name as keyof typeof iconsMap] || iconsMap[`${name}-sharp-outlined` as keyof typeof iconsMap] || iconsMap.empty;

  if (!(name in iconsMap)) {
    console.warn(`Icon not found in iconsMap: ${name}`);
  }

  const [IconComponent, loading, error] = useAsyncIcon({
    asyncFunction: iconResolver as any,
    defaultValue: null,
  });

  if (error) {
    return error.message;
  }

  if (loading || !IconComponent) {
    return null;
  }
  return (
    <IconComponent.type
      {...IconComponent.props}
      data-testid={`icon-${name}`}
      data-cy={dataCy}
      className={cx(className, styles.pathFill, styles[fillColor])}
      style={styleProps}
      width={width}
      height={height}
      viewBox={viewBox}
      title={title}
      fill={fill}
      fillRule={fillRule}
      stroke={stroke}
      strokeWidth={strokeWidth}
      aria-hidden={ariaHidden}
    />
  );
};

export default Icon;
